import {Injectable} from '@angular/core';
import {MenuNotification, OperationType} from '@models/sidebar/menu-notification';
import {MenuNotificationService} from '@services/menu-notification/menu-notification.service';
import {
  FavoriteNotificationService
} from '@services/left-menu/favorites/favorite-notification/favorite-notification.service';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {NotificationService} from '@services/notification/notification.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalHelperService {

  constructor(
    private menuNotificationService: MenuNotificationService,
    private favoriteNotificationService: FavoriteNotificationService,
    private loadingIndicator: LoadingIndicatorService,
    private notificationService: NotificationService,
  ) {
  }

  public handleUpdatedPage(updatedName: string, parentId: string, currentPageName: string, itemId: string, successMessage: string, isTemplatePage:boolean = false) {
    this.menuNotificationService.broadcast(new MenuNotification(OperationType.UPDATE_INSIDE_PARENT, parentId, '', updatedName));
    this.favoriteNotificationService.broadcast(new MenuNotification(OperationType.UPDATE_NAME, itemId, '', updatedName, isTemplatePage));
    this.loadingIndicator.hide();
    this.notificationService.success(successMessage, currentPageName, false);
  }
}
